/* import __COLOCATED_TEMPLATE__ from './infinite-scroll-item-selector-field.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/ember';
const DEFAULT_PAGE_SIZE = 100;
const SEARCH_DEBOUNCE_MS = 500;
let InfiniteScrollItemSelectorField = (_class = class InfiniteScrollItemSelectorField extends Component {
  get allowedItemTypes() {
    if (this.args.allowedItemTypes) {
      return this.args.allowedItemTypes;
    }
    return [];
  }
  get label() {
    return this.args.label ?? this.intl.t('sharedUi.items');
  }
  get modalOptions() {
    return {
      title: this.args.title ?? this.intl.t('sharedUi.infiniteScrollItemSelectorField.title'),
      primaryButtonLabel: this.args.primaryButtonLabel ?? this.intl.t('sharedUi.infiniteScrollItemSelectorField.primaryButtonLabel'),
      enableSearch: this.args.enableSearch ?? false,
      searchPlaceholder: this.intl.t('sharedUi.infiniteScrollItemSelectorField.searchPlaceholder')
    };
  }
  get hasMoreItemsToLoad() {
    return Boolean(this.nextPageToken);
  }
  get itemQueryOptions() {
    return {
      useSearchCatalog: true,
      productTypes: this.allowedItemTypes,
      paginationToken: this.nextPageToken,
      pageSize: this.pageSize,
      includedRelationships: [{
        key: 'itemFeeMemberships',
        includedRelationships: ['fee']
      }]
    };
  }
  get itemsLabel() {
    const {
      selectedOptionIds,
      deselectedOptionIds,
      selectedAllOptions,
      deselectedAllOptions
    } = this.itemSelectionState;
    if (selectedAllOptions && deselectedOptionIds.size === 0) {
      return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.allItems');
    }
    if (deselectedAllOptions && selectedOptionIds.size === 0) {
      return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.noItems');
    }
    if (selectedAllOptions && deselectedOptionIds.size > 0) {
      return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.multipleItems');
    }
    if (deselectedAllOptions && selectedOptionIds.size > 0) {
      return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.itemsCount', {
        count: selectedOptionIds.size
      });
    }
    if (selectedOptionIds.size > 0) {
      if (!this.hasMoreItemsToLoad && selectedOptionIds.size === this.itemOptions.length) {
        return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.allItems');
      } else if (selectedOptionIds.size === 1) {
        return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.oneItem');
      } else {
        return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.itemsCount', {
          count: selectedOptionIds.size
        });
      }
    }
    return this.intl.t('sharedUi.infiniteScrollItemSelectorField.label.noItems');
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isLoading", _descriptor, this);
    _initializerDefineProperty(this, "itemOptions", _descriptor2, this);
    _initializerDefineProperty(this, "nextPageToken", _descriptor3, this);
    _initializerDefineProperty(this, "pageSize", _descriptor4, this);
    _initializerDefineProperty(this, "showItemSelectionModal", _descriptor5, this);
    _initializerDefineProperty(this, "isSearchingItems", _descriptor6, this);
    _initializerDefineProperty(this, "store", _descriptor7, this);
    _initializerDefineProperty(this, "intl", _descriptor8, this);
    _initializerDefineProperty(this, "itemSelectionState", _descriptor9, this);
    this.itemSelectionState = {
      ...this.args.selectionState,
      selectedOptionIds: new Set(this.args.selectionState.selectedOptionIds),
      deselectedOptionIds: new Set(this.args.selectionState.deselectedOptionIds)
    };
  }
  async open() {
    if (this.isLoading) {
      return;
    }
    try {
      this.showItemSelectionModal = true;
      this.isLoading = true;
      await this.loadItemOptions({
        searchTerm: '',
        replaceItems: true
      });
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      this.isLoading = false;
    }
  }
  confirm(selectionState) {
    this.itemSelectionState = {
      ...selectionState,
      selectedOptionIds: new Set(selectionState.selectedOptionIds),
      deselectedOptionIds: new Set(selectionState.deselectedOptionIds)
    };
    this.showItemSelectionModal = false;
    this.args.onConfirm(selectionState);
  }
  close() {
    this.showItemSelectionModal = false;
  }
  async loadItemOptions({
    searchTerm = '',
    replaceItems = false
  }) {
    const response = await this.store.query('item', {
      ...this.itemQueryOptions,
      text: searchTerm,
      attributes: {
        dummy: true
      }
    });
    this.nextPageToken = response.meta.nextPageToken;
    const newItemOptions = response.toArray().sort(this.itemCompareFn).map(this.createItemOption.bind(this));
    this.itemOptions = replaceItems ? [...newItemOptions] : [...this.itemOptions, ...newItemOptions];
    this.deriveItemSelectionState(newItemOptions);
  }
  searchItemsWithDebounce(searchTerm) {
    debounce(this, this.searchItems, searchTerm, SEARCH_DEBOUNCE_MS, false);
  }
  async searchItems(query) {
    try {
      this.nextPageToken = '';
      this.isSearchingItems = true;
      await this.loadItemOptions({
        searchTerm: query,
        replaceItems: true
      });
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      this.isSearchingItems = false;
    }
  }
  deriveItemSelectionState(itemOptions) {
    this.itemSelectionState = itemOptions.reduce((selectionState, itemOption) => {
      if (itemOption.checked) {
        selectionState.selectedOptionIds.add(itemOption.id);
      }
      return selectionState;
    }, {
      ...this.itemSelectionState
    });
  }
  createItemOption(item) {
    const option = {
      id: item.id,
      value: item,
      label: item.name,
      checked: this.args.isItemSelected(item)
    };
    if (this.args.isItemDisabled) {
      const {
        disabled,
        reason
      } = this.args.isItemDisabled(item);
      option.disabled = disabled;
      option.labelTertiary = reason;
    }
    return option;
  }
  itemCompareFn(itemOne, itemTwo) {
    const itemOneName = itemOne.name.toUpperCase();
    const itemTwoName = itemTwo.name.toUpperCase();
    if (itemOneName < itemTwoName) {
      return -1;
    } else if (itemOneName > itemTwoName) {
      return 1;
    } else {
      return 0;
    }
  }
  handleLoadMore() {
    return this.loadItemOptions({
      searchTerm: ''
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "itemOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "nextPageToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "pageSize", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.pageSize ?? DEFAULT_PAGE_SIZE;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showItemSelectionModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isSearchingItems", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "itemSelectionState", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      selectedOptionIds: new Set(),
      deselectedOptionIds: new Set(),
      selectedAllOptions: false,
      deselectedAllOptions: false
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "open", [action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadItemOptions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadItemOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchItemsWithDebounce", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchItemsWithDebounce"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleLoadMore", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleLoadMore"), _class.prototype), _class);
export { InfiniteScrollItemSelectorField as default };